import { useStaticQuery, graphql } from 'gatsby';
import useTransformMenus from './use-transform-menus';
import '../fragments/menus-menuitems';
import '../fragments/menus-submenuitems';

const useMenuItems = () => {
  const { strapiMenus } = useStaticQuery(graphql`
    fragment AllMenuMenuItems on STRAPI__COMPONENT_MENUS_MENUITEM {
      id
      externalpage {
        id
        externalLink
        externalTitle
      }
      page {
        id
        slug
        title
      }
      homepage
      subpages {
        page {
          id
          slug
          title
        }
        externalpage {
          id
          externalLink
          externalTitle
        }
        preview {
          id
          page {
            id
            slug
          }
          title
          content
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  width: 480
                  quality: 100
                  placeholder: BLURRED
                )
              }
            }
          }
        }
        ...MenusSubmenuitems
      }
      icon {
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: FIXED
              width: 20
              quality: 100
              placeholder: BLURRED
            )
          }
        }
      }
      ...MenusMenuitems
    }

    query UseStrapi4MenuItemsWithTop {
      strapiMenus: allStrapiMenu(
        sort: { priority: ASC }
        filter: {
          position: {
            in: ["MainMenu", "top"]
          }
        }
      ) {
        nodes {
          id
          title
          position
          items {
            ...AllMenuMenuItems
          }
          ...MenusMenu
        }
      }
    }
  `);
  const menus = useTransformMenus(strapiMenus);

  return {
    menuItems: menus[0]?.items,
    menus,
  };
};

export default useMenuItems;
